export class GetRetentionScheduleList {
    constructor(retentionScheduleRepository) {
      this.retentionScheduleRepository = retentionScheduleRepository;
    }
  
    async execute(companyId) {
        console.log('GetRetentionScheduleList - companyId : '+ companyId)
      return await this.retentionScheduleRepository.getRetentionScheduleList(companyId);
    }
  }